import { alpha } from "@mui/material/styles";

const PRIMARY = {
  lighter: "#F3F3F3",
  light: "#B8B8B8",
  main: "#E9504A",
  blur: "#767676",
  dark: "#223451",
  darker: "#090305",
};

const SECONDARY = {
  main: "#AAAAAA",
};

const SUCCESS = {
  lighter: "#E9FCD4",
  light: "#AAF27F",
  main: "#54D62C",
  dark: "#229A16",
  darker: "#08660D",
};
const WARNING = {
  lighter: "#FFF7CD",
  light: "#FFE16A",
  main: "#FFC107",
  dark: "#B78103",
  darker: "#7A4F01",
};
const ERROR = {
  lighter: "#FFE7D9",
  light: "#FFA48D",
  main: "#FF4842",
  dark: "#B72136",
  darker: "#7A0C2E",
};

const GREY = {
  0: "#FFFFFF",
  100: "#F9FAFB",
  200: "#F4F6F8",
  300: "#DFE3E8",
  400: "#C4CDD5",
  500: "#fff",
  600: "#637381",
  700: "#454F5B",
  800: "#212B36",
  900: "#161C24",
  500_8: alpha("#fff", 0.08),
  500_12: alpha("#fff", 0.12),
  500_16: alpha("#fff", 0.16),
  500_24: alpha("#fff", 0.24),
  500_32: alpha("#fff", 0.32),
  500_48: alpha("#fff", 0.48),
  500_56: alpha("#fff", 0.56),
  500_80: alpha("#B8B8B8", 0.8),
};

const COMMON = {
  common: { black: "#000", white: "#fff" },
  primary: { ...PRIMARY, contrastText: "#fff" },
  secondary: { ...SECONDARY },
  success: { ...SUCCESS, contrastText: GREY[800] },
  warning: { ...WARNING, contrastText: GREY[800] },
  error: { ...ERROR, contrastText: "#fff" },
  grey: GREY,
  divider: GREY[500_24],
  action: {
    active: GREY[500],
    hover: GREY[500_8],
    selected: GREY[500_16],
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

const palette = {
  ...COMMON,
  background: { default: "#fff" },
  fontColor: { default: "#1E1E1E" },
  fontFamily: { default: "Inter" },
  // sd: { default: "0px 4px 4px 0px #00000040" },
};

export default palette;
